<template>
  <div class="page-wrap">
    <el-card class="page-card--full">
    <div class="page-card-body" ref="pageRoot">
      <div ref="queryBar" style="display:flex;gap:12px;align-items:center;flex-wrap:wrap;">
        <el-input v-model="keyword" placeholder="机场名/三字码/城市/省份" style="width:280px" clearable @keyup.enter.native="load" />
        <el-select v-model="status" placeholder="状态" clearable style="width:140px" @change="load">
          <el-option label="启用" :value="1" />
          <el-option label="停用" :value="0" />
        </el-select>
        <el-select v-model="type" placeholder="类型" clearable style="width:140px" @change="load">
          <el-option label="出发(1)" :value="1" />
          <el-option label="到达(2)" :value="2" />
        </el-select>
        <el-button type="primary" @click="openCreate">新增机场</el-button>
        <el-button @click="load">刷新</el-button>
      </div>

      <el-table :data="list" :height="tableHeight" style="width:100%;" size="small">
        <el-table-column prop="code" label="三字码" width="100" />
        <el-table-column prop="name" label="机场" />
        <el-table-column prop="city" label="城市" width="140" />
        <el-table-column prop="province" label="省份" width="140" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="s">
            <el-tag :type="s.row.status===1?'success':'info'">{{ s.row.status===1?'启用':'停用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="s">
            <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
            <el-button type="text" style="color:#ef4444" @click="remove(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div ref="pagerBar" class="pager-bar">
        <el-pagination
          layout="total, prev, pager, next"
          :current-page.sync="pageNum"
          :page-size="pageSize"
          :total="total"
          @current-change="load"
        />
      </div>
    </div>

    <el-dialog :title="form.id?'编辑机场':'新增机场'" :visible.sync="dlg" width="640px">
      <el-form :model="form" label-width="110px">
        <el-form-item label="三字码"><el-input v-model="form.code" /></el-form-item>
        <el-form-item label="机场名"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="机场类型">
          <el-select v-model="form.type" style="width:100%">
            <el-option label="民用机场(1)" :value="1" />
            <el-option label="军民合用(2)" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="省市区">
          <el-cascader
            v-model="form.regionCodes"
            :options="areaOptions"
            :props="areaCascaderProps"
            clearable
            style="width:100%"
            placeholder="请选择省/市/区"
          />
        </el-form-item>
        <el-form-item label="详细地址"><el-input v-model="form.address" /></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option label="启用" :value="1" />
            <el-option label="停用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态描述"><el-input v-model="form.statusDesc" placeholder="如：正常" /></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dlg=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </span>
    </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request from '../../utils/request'
import tableAutoHeight from '../../mixins/tableAutoHeight'

export default {
  name: 'BizAirport',
  mixins: [tableAutoHeight],
  data() {
    return {
      keyword: '',
      status: null,
      type: null,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      areaOptions: [],
      areaCascaderProps: { value: 'value', label: 'text', children: 'children', emitPath: true, checkStrictly: false },
      dlg: false,
      saving: false,
      form: {
        id: '',
        code: '',
        name: '',
        type: 1,
        regionCodes: [],
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        province: '',
        city: '',
        areaName: '',
        address: '',
        status: 1,
        statusDesc: '正常'
      }
    }
  },
  created() {
    this.loadAreaTree()
    this.load()
  },
  methods: {
    createEmptyForm() {
      return {
        id: '',
        code: '',
        name: '',
        type: 1,
        regionCodes: [],
        provinceCode: '',
        cityCode: '',
        areaCode: '',
        province: '',
        city: '',
        areaName: '',
        address: '',
        status: 1,
        statusDesc: '正常'
      }
    },
    async loadAreaTree() {
      const tree = await request.get('/admin/api/biz/airport/area/tree')
      this.areaOptions = this.toThreeLevelTree(tree || [])
    },
    toThreeLevelTree(tree) {
      return (tree || []).map((province) => ({
        value: province.value,
        text: province.text,
        children: ((province.children || []).map((city) => ({
          value: city.value,
          text: city.text,
          children: ((city.children || []).map((area) => ({
            value: area.value,
            text: area.text,
            leaf: true
          })))
        })))
      }))
    },
    fillRegionTextByCodes(form) {
      const regionCodes = Array.isArray(form.regionCodes) ? form.regionCodes : []
      if (regionCodes.length < 3) return
      const [provinceCode, cityCode, areaCode] = regionCodes
      form.provinceCode = provinceCode
      form.cityCode = cityCode
      form.areaCode = areaCode

      const provinceNode = (this.areaOptions || []).find((item) => item && item.value === provinceCode)
      const cityNode = ((provinceNode && provinceNode.children) || []).find((item) => item && item.value === cityCode)
      const areaNode = ((cityNode && cityNode.children) || []).find((item) => item && item.value === areaCode)

      form.province = (provinceNode && provinceNode.text) || ''
      form.city = (cityNode && cityNode.text) || ''
      form.areaName = (areaNode && areaNode.text) || ''
    },
    async load(page) {
      if (typeof page === 'number') this.pageNum = page
      const pageData = await request.get('/admin/api/biz/airport/page', { params: { keyword: this.keyword, status: this.status, type: this.type, pageNum: this.pageNum, pageSize: this.pageSize } })
      this.list = pageData.records || []
      this.total = pageData.total || 0
      this.$nextTick(() => this.updateTableHeight())
    },
    openCreate() {
      this.form = this.createEmptyForm()
      this.dlg = true
    },
    openEdit(row) {
      this.form = {
        ...this.createEmptyForm(),
        ...row,
        regionCodes: [row.provinceCode, row.cityCode, row.areaCode].filter(Boolean)
      }
      this.dlg = true
    },
    async save() {
      if (this.saving) return
      if (!this.form.code || !this.form.name) {
        this.$message.error('请填写三字码和机场名')
        return
      }
      if (!Array.isArray(this.form.regionCodes) || this.form.regionCodes.length !== 3) {
        this.$message.error('请选择省市区')
        return
      }
      this.saving = true
      try {
        const payload = { ...this.form }
        this.fillRegionTextByCodes(payload)
        delete payload.regionCodes
        if (this.form.id) {
          await request.put('/admin/api/biz/airport/' + this.form.id, payload)
        } else {
          await request.post('/admin/api/biz/airport', payload)
        }
        this.$message.success('已保存')
        this.dlg = false
        await this.load()
      } finally {
        this.saving = false
      }
    },
    async remove(row) {
      await this.$confirm('确认删除该机场？', '提示', { type: 'warning' })
      await request.delete('/admin/api/biz/airport/' + row.id)
      this.$message.success('已删除')
      await this.load()
    }
  }
}
</script>

